import apiService from "./apiService";
import AppConstants from "../appConstants";

class AuthTokenService {
    getall(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_AUTHTOKEN, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    deleteToken(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_AUTHTOKEN_DELETE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new AuthTokenService();
